import { useEffect } from "react";

const LoadScripts = () => {
    useEffect(() => {
      const scripts = [
        "assets/js/jquery-3.7.0.min.js",
        "assets/js/bootstrap.bundle.min.js",
        "assets/js/gsap.min.js",
        "assets/js/scrollTrigger.min.js",
        "assets/js/text-opacity.js",
        "assets/js/odometer.js",
        // "assets/js/leaflet.js",
        // "assets/js/leaflet-routing-machine.min.js",
        // "assets/js/leaflet-scripts.js",
        "assets/js/jquery.magnific-popup.min.js",
        "assets/js/swiper-bundle.min.js",
        "assets/js/scripts.js",
      ];
  
      const loadScript = (src) => {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = src;
          script.async = true;
          script.onload = () => resolve();
          script.onerror = () => reject(`Failed to load ${src}`);
          document.body.appendChild(script);
        });
      };
  
      // Load all scripts in sequence
      const loadAllScripts = async () => {
        try {
          for (let src of scripts) {
            await loadScript(src);
          }
          console.log("All scripts loaded");
        } catch (err) {
          console.error(err);
        }
      };
  
      loadAllScripts();
  
      // Cleanup on component unmount
      return () => {
        scripts.forEach((src) => {
          const scriptTag = document.querySelector(`script[src="${src}"]`);
          if (scriptTag) {
            document.body.removeChild(scriptTag);
          }
        });
      };
    }, []);
  
    return null;
  };
  
  export default LoadScripts;